(ns ui.view.opensearch-value.currency
  "Where the currency of a value is. A currency value, for example the ticket size,
   has a second field that holds its currency, the secondary attribute of the
   field. A listing shows the value with the currency of its row, so it must ask
   the search for the second field, and read it from the row. The functions here
   do not read the session or the row of a view. The caller gives the data."
  (:require
   [clojure.string :as string]
   [common.schema.registry :as registry]
   [common.util :as cu]))

(defn- normalize-field-path
  [field-path]
  (cond
    (keyword? field-path) [field-path]
    (sequential? field-path) (vec field-path)
    :else nil))

(defn currency-field-path
  "The path of the field that holds the currency of the values of a currency
   field, or nil when `field-schema` is not a currency field or has no such
   field. It is `field-path` with the secondary attribute of the field in place
   of its last element, so the field of a related entity keeps its path."
  [{:keys [field-path field-schema]}]
  (let [secondary-attribute (:field/secondary-attribute field-schema)
        path (normalize-field-path field-path)]
    (when (and (= :data.type/currency-value (:field/data-type field-schema))
               (keyword? secondary-attribute)
               (seq path))
      (conj (pop path) secondary-attribute))))

(defn stored->currency
  "The currency that the index holds for a row, as a keyword, or nil. The index
   holds a keyword as a text with a colon, for example `:sek`. A text that is
   blank, and a value that is not a text or a keyword, give nil."
  [stored]
  (cond
    (keyword? stored)
    stored

    (and (string? stored)
         (not (string/blank? stored)))
    (let [currency (cu/str->keyword-if-string stored)]
      (when (keyword? currency)
        currency))

    :else
    nil))

(defn card-currency-field-paths
  "The paths of the fields that hold the currency of the currency values that a
   card shows: the header, the body and the footer fields of `card-config`. The
   search throws for a field that the user cannot read, so only a path that is in
   `accessible-field-paths` is given. `tenant-schema` is the schema that has the
   fields of the tenant. It can be nil, and then the schema of the product is
   used."
  [{:keys [card-config tenant-schema accessible-field-paths]}]
  (let [accessible (into #{} (keep normalize-field-path) accessible-field-paths)]
    (->> (concat (:header-fields card-config)
                 (:body-fields card-config)
                 (:footer-fields card-config))
         (keep normalize-field-path)
         distinct
         (keep (fn [field-path]
                 (currency-field-path
                  {:field-path   field-path
                   :field-schema (registry/get-field-schema tenant-schema (peek field-path))})))
         (filter accessible)
         distinct
         vec)))
